import { render, staticRenderFns } from "./NotebookDetails.vue?vue&type=template&id=3724d9fb&"
import script from "./NotebookDetails.vue?vue&type=script&lang=js&"
export * from "./NotebookDetails.vue?vue&type=script&lang=js&"
import style0 from "./NotebookDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports